import { getUserServiceUrl } from './backend'
import { getAuthHeaders } from './sessionAuth'

const SESSION_USER_ID_KEY = 'scribbl_session_user_id'

const getSessionStorage = () => {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage
  } catch {
    return null
  }
}

const getLegacySessionStorage = () => {
  if (typeof window === 'undefined') return null
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

export const getSessionUserId = (): string | null => {
  const storage = getSessionStorage()
  if (!storage) return null
  const saved = storage.getItem(SESSION_USER_ID_KEY)
  if (saved && saved.trim()) return saved
  const legacySaved = getLegacySessionStorage()?.getItem(SESSION_USER_ID_KEY)
  if (!legacySaved || !legacySaved.trim()) return null
  storage.setItem(SESSION_USER_ID_KEY, legacySaved)
  getLegacySessionStorage()?.removeItem(SESSION_USER_ID_KEY)
  return legacySaved
}

export const setSessionUserId = (id: string) => {
  const storage = getSessionStorage()
  if (!storage) return
  storage.setItem(SESSION_USER_ID_KEY, id)
  getLegacySessionStorage()?.removeItem(SESSION_USER_ID_KEY)
}

export const clearSessionUserId = () => {
  const storage = getSessionStorage()
  if (!storage) return
  storage.removeItem(SESSION_USER_ID_KEY)
  getLegacySessionStorage()?.removeItem(SESSION_USER_ID_KEY)
}

const fetchUserIdByEmail = async (url: string) => {
  const resp = await fetch(url, {
    headers: getAuthHeaders(),
    credentials: 'include',
  })
  if (!resp.ok) return null
  let data: unknown = null
  try {
    data = await resp.json()
  } catch {
    data = null
  }
  const id = typeof data === 'string' ? data : (data as { id?: string })?.id
  return id ? String(id) : null
}

export const ensureSessionUserId = async (email: string | null | undefined) => {
  const existing = getSessionUserId()
  if (existing) return existing
  if (!email) return null
  
  console.log(`[sessionUser] Checking backend DB for user email: ${email}`);
  try {
    const baseUrl = getUserServiceUrl()
    const direct = await fetchUserIdByEmail(
      `${baseUrl}/user/?email=${encodeURIComponent(email)}`,
    )
    if (direct) {
      setSessionUserId(direct)
      return direct
    }
    const legacy = await fetchUserIdByEmail(
      `${baseUrl}/user/id/?email=${encodeURIComponent(email)}`,
    )
    if (legacy) {
      setSessionUserId(legacy)
      return legacy
    }
  } catch (err) {
    console.error('Failed to ensure session user id', err)
  }
  return null
}
